import React from "react";
import SearchIcon from "@material-ui/icons/Search";

export function Searchbar(props) {
  const { filter, style } = props;
  const {
    iconColor,
    background,
    borderWidth,
    borderRadius,
    color,
    fontSize,
    fontWeight,
    fontFamily,
    width,
    borderColor,
  } = style;
  return (
    <div
      className="chat-searchbar"
      style={{
        background,
        borderWidth,
        borderRadius,
        width,
        borderColor,
        margin: "auto",
      }}
    >
      <div className="prepend-icon ">
        <SearchIcon style={{ color: iconColor }} />
      </div>
      <input
        style={{ color, fontSize, fontWeight, fontFamily }}
        className="input-field"
        onChange={(e) => filter(e.target.value)}
      />
    </div>
  );
}
